import React, { Component } from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import AppBar from 'material-ui/AppBar';
import {tealA100} from 'material-ui/styles/colors';
import injectTapEventPlugin from 'react-tap-event-plugin';

import Drawer from 'material-ui/Drawer';
import MenuItem from 'material-ui/MenuItem';


injectTapEventPlugin();

const muiTheme = getMuiTheme ({
 palette: {
   primary1Color: tealA100,
 }
});

class NavBar extends Component {
  constructor(props) {
  super(props);
  this.state = {open: false};
}

  handleToggle = () => this.setState({open: !this.state.open});

  render(){
    return(
      <div>
        <MuiThemeProvider muiTheme={muiTheme}>
          <AppBar
            onLeftIconButtonClick={this.handleToggle}
          />

        </MuiThemeProvider>

        <MuiThemeProvider muiTheme={muiTheme}>
          <Drawer
            docked={false}
            width={200}
            open={this.state.open}
            onRequestChange={(open) => this.setState({open})}>
            <MenuItem href='https://github.com/ahylton19' target='_blank'>GitHub</MenuItem>
            <MenuItem href='https://codepen.io/collection/nVPVgR/#' target='_blank'>CodePen</MenuItem>
            <MenuItem href='https://www.linkedin.com/in/akil-hylton-74124661/' target='_blank'>LinkedIn</MenuItem>
            <MenuItem href='https://standardresume.co/akilhylton'>Resume</MenuItem>
          </Drawer>
        </MuiThemeProvider>
      </div>
        );
  }
}

export default NavBar;



// WEBPACK FOOTER //
// ./src/container/NavBar/NavBar.js